/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../components/loading/loading.component';
import has from 'lodash/has';
import * as consts from '../../const';
import StudiesService from './studies.service';
import Notification from '../common/notification/notification.component';
import { Tabs, Tab } from 'react-bootstrap';
import QlikReportComponent from './qlik-reports/qlik-report.component';
import { path } from 'ramda';

let noStudiesInfo = <Notification type="info" data="No studies found." />;

class StudiesComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 1
    };

    this.onTabSelect = this.onTabSelect.bind(this);
    this.hasAuthorizedUserRole = this.hasAuthorizedUserRole.bind(this);
  }

  componentDidMount() {
    this.props.loadData(this.props.userId, this.props.selectedSponsor.databasename);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    let hasNewName = has(newProps.selectedSponsor, 'databasename');
    let hasName = has(this.props.selectedSponsor, 'databasename');
    if (hasNewName) {
      let currentSponsor = null;

      if (hasName) {
        currentSponsor = this.props.selectedSponsor.databasename;
      }

      if (newProps.selectedSponsor.databasename !== currentSponsor) {
        this.props.loadData(newProps.userId, newProps.selectedSponsor.databasename);
        if (this.state.tab === 2) {
          this.props.loadReports(newProps.userId, newProps.selectedSponsor.databasename);
        }
      }
    }
  }

  onTabSelect(key) {
    this.setState(() => ({ tab: key }));
    if (key === 2) {
      this.props.loadReports(this.props.userId, this.props.selectedSponsor.databasename);
    }
  }

  hasAuthorizedUserRole(authorizedRole) {
    if (this.props.rows && this.props.rows.data) {
      const userRole = path(['rows', 'data', 'assignments', 'data', 0, 'userRole', 'roleName'], this.props);
      return userRole === authorizedRole;
    } else {
      return false;
    }
  }

  displayReportsTab() {
    const authorizedRoles = ['CRFB_SUPER_USER', 'SPONSOR_SUPER_USER', 'SPONSOR_STUDY_MANAGER', 'HELPDESK_USER'];
    if (authorizedRoles.find((item) => this.hasAuthorizedUserRole(item))) {
      this.props.getReportsStatus(this.props.selectedSponsor.databasename);
      return this.props.reportsEnabled;
    } else {
      return false;
    }
  }

  render() {
    let studies, notification, count;

    if (this.props.isFetching || !this.props.selectedSponsor) {
      return <Loading />;
    }

    if (this.props.error) {
      notification = <Notification type="error" data={this.props.error} />;
    } else {
      if (StudiesService.hasStudies(this.props.rows)) {
        if (this.props.rows.data.studies.data.length == 0) {
          notification = this.props.rows.data.studies.data.length > 0 ? <span /> : noStudiesInfo;
        }
      }
    }

    count = StudiesService.hasStudies(this.props.rows) ? this.props.rows.data.studies.data.length : 0;
    studies = StudiesService.createGrid(this.props.rows);
    if (this.displayReportsTab()) {
      return (
        <Tabs activeKey={this.state.tab} onSelect={this.onTabSelect} id="landing-page-tabs">
          <Tab eventKey={1} title={`${consts.ACTIVE_STUDIES} (${count})`}>
            <div id="studies-component">
              {studies}
              {notification}
            </div>
          </Tab>
          <Tab eventKey={2} title={consts.REPORTS}>
            <QlikReportComponent
              reports={this.props.reports}
              error={this.props.reportsError}
              isFetching={this.props.isFetchingReports}
            />
          </Tab>
        </Tabs>
      );
    } else {
      return (
        <div id="studies-component">
          <h4 className="title">
            {consts.ACTIVE_STUDIES} ({count})
          </h4>
          {studies}
          {notification}
        </div>
      );
    }
  }
}

StudiesComponent.propTypes = {
  isFetching: PropTypes.bool,
  rows: PropTypes.any.isRequired,
  reports: PropTypes.any.isRequired,
  isFetchingReports: PropTypes.bool,
  error: PropTypes.object,
  reportsError: PropTypes.object,
  loadData: PropTypes.func.isRequired,
  loadReports: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  selectedSponsor: PropTypes.object.isRequired,
  getReportsStatus: PropTypes.func.isRequired,
  reportsEnabled: PropTypes.bool
};

export default StudiesComponent;
